<template>
  <div class="c-key-phone">
    <label for="phone" class="title">Informe seu celular</label>

    <div class="field-body column is-full">
      <div class="field">
        <div class="control">
          <input
            id="phone"
            class="input has-value"
            placeholder="celular"
            name="phone"
            type="tel"
            autocomplete="off"
            maxlength="11"
            minlength="10"
            v-model.lazy="phone"
            @keypress="onlyNumberOnKeypress"
            @change="updateValue"
          />
          <i class="bar"></i>
          <p v-if="validation.hasError('phone')" class="help is-error">
            {{ validation.firstError('phone') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleVueValidator from 'simple-vue-validator'

const Validator = SimpleVueValidator.Validator.create({
  templates: {
    required: 'Este campo não pode ficar vazio.',
    digit: 'Este campo deve conter apenas números.',
    minLength:
      'O número deve conter no mínimo 10 digitos com o DDD. Ex: 1199999999',
    maxLength:
      'O número deve conter no máximo 11 digitos com o DDD. Ex: 11999999999',
  },
})

export default {
  mixins: [SimpleVueValidator.mixin],

  data() {
    return {
      phone: '',
    }
  },

  validators: {
    phone: (value) => {
      return Validator.value(value)
        .required()
        .digit()
        .minLength(10)
        .maxLength(11)
    },
  },

  computed: {
    hasErrors() {
      return this.validation.hasError('phone')
    },
  },

  methods: {
    async updateValue() {
      await this.$validate()
      this.$emit('change', {
        key: this.phone,
        error: this.hasErrors,
      })
    },

    onlyNumberOnKeypress($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-key-phone {
  .title {
    margin-bottom: 40px;
    font-size: 20px;
    line-height: 100%;
    font-weight: bold;
    color: $gray-7;
  }

  .another-key {
    cursor: pointer;
    font-size: 18px;
    font-weight: 700;
    line-height: 21.6px;
    color: $support;
    margin-bottom: 50px;
    i {
      margin-left: 4px;
      font-size: medium;
    }
  }

  input {
    color: $neutral !important;
    font-size: 20px;
    font-weight: 700;
    line-height: 100%;
  }

  .field-body {
    padding-left: 0;
    margin-bottom: 50px;
  }
}
</style>
